<template>
  <div
    class="machines-table"
    style="height: 100%;">

    <el-divider v-if="!tableIsNotEmpty"/>
    <div
      v-if="!tableIsNotEmpty"
      class="boxes-table-no-data-container">
      <div class="boxes-table-no-data-container-body">
        <div class="boxes-table-no-data-image" />
        <div class="mt-24 el-text el-text--display-regular">
          {{ $t('wre-dashboard.machines-table.message.no-machines') }}
        </div>
      </div>
    </div>

    <el-table
      v-if="tableIsNotEmpty"
      style="height: 100%;"
      height="fit-scrollable"
      :data="machineList"
      highlight-current-row
      :default-sort = "{ prop: 'displayName' }"
      :loading-append="isFetchSubAccountItemsInProgress"
      @row-click="onTableRowClick"
      ref="table"
      border-bottom>

      <el-table-column
        prop="id"
        label="id"
        hidden/>

      <el-table-column
        prop="displayName"
        :label="$t('wre-dashboard.machines-table.column.name')"
        align="left"
        sortable>
        <template slot-scope="{ row }">
          <el-icon name="svg-pc-clr--32"/>
          <span class="ml-16">
            {{ row.displayName }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="size"
        align="right"
        width="180"
        :label="$t('wre-dashboard.machines-table.column.size')"
        :sort-by="row => row.space.used"
        sortable>
        <template slot-scope="{ row }">
          {{ row.space.used | size }}
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  PENDING_STATUS
} from '../store/action-status';

const { mapGetters } = createNamespacedHelpers('wre-dashboard');

export default {
  name: 'MachinesTable',
  props: {
    machineList: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getFetchSubAccountItemsStatus'
    ]),
    isFetchSubAccountItemsInProgress() {
      return this.getFetchSubAccountItemsStatus === PENDING_STATUS;
    },
    tableIsNotEmpty() {
      return this.isFetchSubAccountItemsInProgress || this.machineList.length > 0;
    }
  },
  methods: {
    onTableRowClick(row, event, column) {
      this.$emit('machineSelected', {
        subAccountId: row.id,
        displayName: row.displayName
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .boxes-table-no-data-container {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .boxes-table-no-data-container-body {
    margin-left: 256px;
    margin-top: -78px;
  }

  .boxes-table-no-data-image {
    margin: auto;
    background: url('../assets/empty/empty-cloud.png') no-repeat;
    width: 128px;
    height: 128px;
  }
</style>
